import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div className="unauthorized-container">
      <h2>Access Denied</h2>
      <p>You do not have permission to view this page.</p>
      <Link to="/login">Login</Link>
    </div>
  );
};

export default UnauthorizedPage;
